import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { EyeIcon, EyeOffIcon, CheckIcon } from 'lucide-react';
import { Button } from '../components/Button';
export function Signup() {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
    plan: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const validateStep1 = () => {
    const newErrors = {
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      confirmPassword: ''
    };
    let isValid = true;
    if (!formData.firstName.trim()) {
      newErrors.firstName = 'First name is required';
      isValid = false;
    }
    if (!formData.lastName.trim()) {
      newErrors.lastName = 'Last name is required';
      isValid = false;
    }
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid';
      isValid = false;
    }
    if (!formData.password.trim()) {
      newErrors.password = 'Password is required';
      isValid = false;
    } else if (formData.password.length < 8) {
      newErrors.password = 'Password must be at least 8 characters';
      isValid = false;
    }
    if (formData.confirmPassword !== formData.password) {
      newErrors.confirmPassword = 'Passwords do not match';
      isValid = false;
    }
    setErrors(newErrors);
    return isValid;
  };
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
  const handleSubmit = e => {
    e.preventDefault();
    if (step === 1 && validateStep1()) {
      setStep(2);
    } else if (step === 2) {
      // Submit the form data to backend (simulated)
      console.log('Form submitted:', formData);
      // Redirect to onboarding page instead of dashboard
      window.location.href = '/onboarding';
    }
  };
  const handleSelectPlan = plan => {
    setFormData({
      ...formData,
      plan
    });
  };
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };
  return <div className="w-full min-h-screen bg-[#1E2A38] text-[#F5F7FA] font-sans flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8" data-id="element-3491">
      <div className="max-w-md w-full bg-[#1A2331] rounded-xl shadow-lg overflow-hidden" data-id="element-3492">
        <div className="p-8" data-id="element-3493">
          <div className="flex justify-center mb-6" data-id="element-3494">
            <Link to="/" className="flex items-center" data-id="element-3495">
              <svg className="h-10 w-auto" viewBox="0 0 50 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3496">
                <path d="M10 4H20C22.2091 4 24 5.79086 24 8V16C24 18.2091 22.2091 20 20 20H10C7.79086 20 6 18.2091 6 16V8C6 5.79086 7.79086 4 10 4Z" fill="#C8F169" data-id="element-3497" />
                <path d="M30 4H40C42.2091 4 44 5.79086 44 8V16C44 18.2091 42.2091 20 40 20H30C27.7909 20 26 18.2091 26 16V8C26 5.79086 27.7909 4 30 4Z" fill="#C8F169" data-id="element-3498" />
                <path d="M12 10L18 14L12 18V10Z" fill="#1E2A38" data-id="element-3499" />
              </svg>
            </Link>
          </div>
          <h1 className="text-2xl font-bold text-center mb-2" data-id="element-3500">
            Create Your Account
          </h1>
          <p className="text-center text-[#F5F7FA] text-opacity-70 mb-8" data-id="element-3501">
            Sign up to access personalized meeting briefs, AI insights, and
            more!
          </p>
          {/* Progress indicator */}
          <div className="flex items-center justify-center mb-8" data-id="element-3502">
            <div className={`h-2 w-2 rounded-full ${step >= 1 ? 'bg-[#C8F169]' : 'bg-[#F5F7FA] bg-opacity-20'} mr-1`} data-id="element-3503"></div>
            <div className={`h-2 w-2 rounded-full ${step >= 2 ? 'bg-[#C8F169]' : 'bg-[#F5F7FA] bg-opacity-20'}`} data-id="element-3504"></div>
          </div>
          {step === 1 ? <form onSubmit={handleSubmit} data-id="element-3505">
              <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-3506">
                <div data-id="element-3507">
                  <label htmlFor="firstName" className="block text-sm font-medium mb-1" data-id="element-3508">
                    First Name
                  </label>
                  <input type="text" id="firstName" name="firstName" value={formData.firstName} onChange={handleChange} className={`w-full bg-[#1E2A38] border ${errors.firstName ? 'border-red-500' : 'border-[#F5F7FA] border-opacity-10'} rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#C8F169] focus:ring-opacity-50`} placeholder="Enter your first name" data-id="element-3509" />
                  {errors.firstName && <p className="mt-1 text-xs text-red-500" data-id="element-3510">
                      {errors.firstName}
                    </p>}
                </div>
                <div data-id="element-3511">
                  <label htmlFor="lastName" className="block text-sm font-medium mb-1" data-id="element-3512">
                    Last Name
                  </label>
                  <input type="text" id="lastName" name="lastName" value={formData.lastName} onChange={handleChange} className={`w-full bg-[#1E2A38] border ${errors.lastName ? 'border-red-500' : 'border-[#F5F7FA] border-opacity-10'} rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#C8F169] focus:ring-opacity-50`} placeholder="Enter your last name" data-id="element-3513" />
                  {errors.lastName && <p className="mt-1 text-xs text-red-500" data-id="element-3514">
                      {errors.lastName}
                    </p>}
                </div>
              </div>
              <div className="mb-4" data-id="element-3515">
                <label htmlFor="email" className="block text-sm font-medium mb-1" data-id="element-3516">
                  Email address
                </label>
                <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className={`w-full bg-[#1E2A38] border ${errors.email ? 'border-red-500' : 'border-[#F5F7FA] border-opacity-10'} rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#C8F169] focus:ring-opacity-50`} placeholder="you@example.com" data-id="element-3517" />
                {errors.email && <p className="mt-1 text-xs text-red-500" data-id="element-3518">{errors.email}</p>}
              </div>
              <div className="mb-4" data-id="element-3519">
                <label htmlFor="password" className="block text-sm font-medium mb-1" data-id="element-3520">
                  Password
                </label>
                <div className="relative" data-id="element-3521">
                  <input type={showPassword ? 'text' : 'password'} id="password" name="password" value={formData.password} onChange={handleChange} className={`w-full bg-[#1E2A38] border ${errors.password ? 'border-red-500' : 'border-[#F5F7FA] border-opacity-10'} rounded-lg px-4 py-2 pr-10 focus:outline-none focus:ring-2 focus:ring-[#C8F169] focus:ring-opacity-50`} placeholder="Create a password" data-id="element-3522" />
                  <button type="button" className="absolute inset-y-0 right-0 pr-3 flex items-center text-sm" onClick={togglePasswordVisibility} data-id="element-3523">
                    {showPassword ? <EyeOffIcon className="h-5 w-5 text-[#F5F7FA] text-opacity-60" data-id="element-3524" /> : <EyeIcon className="h-5 w-5 text-[#F5F7FA] text-opacity-60" data-id="element-3525" />}
                  </button>
                </div>
                {errors.password && <p className="mt-1 text-xs text-red-500" data-id="element-3526">{errors.password}</p>}
              </div>
              <div className="mb-6" data-id="element-3527">
                <label htmlFor="confirmPassword" className="block text-sm font-medium mb-1" data-id="element-3528">
                  Confirm Password
                </label>
                <div className="relative" data-id="element-3529">
                  <input type={showConfirmPassword ? 'text' : 'password'} id="confirmPassword" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} className={`w-full bg-[#1E2A38] border ${errors.confirmPassword ? 'border-red-500' : 'border-[#F5F7FA] border-opacity-10'} rounded-lg px-4 py-2 pr-10 focus:outline-none focus:ring-2 focus:ring-[#C8F169] focus:ring-opacity-50`} placeholder="Confirm your password" data-id="element-3530" />
                  <button type="button" className="absolute inset-y-0 right-0 pr-3 flex items-center text-sm" onClick={toggleConfirmPasswordVisibility} data-id="element-3531">
                    {showConfirmPassword ? <EyeOffIcon className="h-5 w-5 text-[#F5F7FA] text-opacity-60" data-id="element-3532" /> : <EyeIcon className="h-5 w-5 text-[#F5F7FA] text-opacity-60" data-id="element-3533" />}
                  </button>
                </div>
                {errors.confirmPassword && <p className="mt-1 text-xs text-red-500" data-id="element-3534">
                    {errors.confirmPassword}
                  </p>}
              </div>
              <button type="submit" className="w-full bg-[#3B82F6] hover:bg-opacity-90 text-white font-medium py-2 px-4 rounded-lg transition-colors" data-id="element-3535">
                Continue
              </button>
              <div className="mt-6 text-center" data-id="element-3536">
                <div className="relative" data-id="element-3537">
                  <div className="absolute inset-0 flex items-center" data-id="element-3538">
                    <div className="w-full border-t border-[#F5F7FA] border-opacity-10" data-id="element-3539"></div>
                  </div>
                  <div className="relative flex justify-center" data-id="element-3540">
                    <span className="px-2 bg-[#1A2331] text-sm text-[#F5F7FA] text-opacity-70" data-id="element-3541">
                      or with
                    </span>
                  </div>
                </div>
              </div>
              <button type="button" className="mt-4 w-full flex items-center justify-center bg-[#1E2A38] border border-[#F5F7FA] border-opacity-10 text-[#F5F7FA] font-medium py-2 px-4 rounded-lg hover:bg-opacity-90 transition-colors" data-id="element-3542">
                <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-3543">
                  <path d="M12.24 10.285V14.4h6.806c-.275 1.765-2.056 5.174-6.806 5.174-4.095 0-7.439-3.389-7.439-7.574s3.345-7.574 7.439-7.574c2.33 0 3.891.989 4.785 1.849l3.254-3.138C18.189 1.186 15.479 0 12.24 0c-6.635 0-12 5.365-12 12s5.365 12 12 12c6.926 0 11.52-4.869 11.52-11.726 0-.788-.085-1.39-.189-1.989H12.24z" fill="#4285F4" data-id="element-3544" />
                  <path d="M12.24 10.285V14.4h6.806c-.275 1.765-2.056 5.174-6.806 5.174-4.095 0-7.439-3.389-7.439-7.574s3.345-7.574 7.439-7.574c2.33 0 3.891.989 4.785 1.849l3.254-3.138C18.189 1.186 15.479 0 12.24 0c-6.635 0-12 5.365-12 12s5.365 12 12 12c6.926 0 11.52-4.869 11.52-11.726 0-.788-.085-1.39-.189-1.989H12.24z" fill="#4285F4" data-id="element-3545" />
                  <path d="M12.24 10.285V14.4h6.806c-.275 1.765-2.056 5.174-6.806 5.174-4.095 0-7.439-3.389-7.439-7.574s3.345-7.574 7.439-7.574c2.33 0 3.891.989 4.785 1.849l3.254-3.138C18.189 1.186 15.479 0 12.24 0c-6.635 0-12 5.365-12 12s5.365 12 12 12c6.926 0 11.52-4.869 11.52-11.726 0-.788-.085-1.39-.189-1.989H12.24z" fill="#4285F4" data-id="element-3546" />
                </svg>
                Login with Google
              </button>
              <p className="mt-6 text-center text-sm" data-id="element-3547">
                If you already have an account please?{' '}
                <Link to="#login" className="text-[#C8F169] hover:underline" data-id="element-3548">
                  Log In
                </Link>
              </p>
            </form> : <div data-id="element-3549">
              <h2 className="text-xl font-bold mb-6" data-id="element-3550">Choose Your Plan</h2>
              <div className="space-y-4 mb-6" data-id="element-3551">
                {/* Free Plan */}
                <div className={`border rounded-lg p-4 cursor-pointer transition-all ${formData.plan === 'free' ? 'border-[#C8F169] bg-[#C8F169] bg-opacity-5' : 'border-[#F5F7FA] border-opacity-10 hover:border-[#F5F7FA] hover:border-opacity-30'}`} onClick={() => handleSelectPlan('free')} data-id="element-3552">
                  <div className="flex justify-between items-center" data-id="element-3553">
                    <div data-id="element-3554">
                      <h3 className="font-medium" data-id="element-3555">Free</h3>
                      <p className="text-sm text-[#F5F7FA] text-opacity-70" data-id="element-3556">
                        $0/month
                      </p>
                    </div>
                    {formData.plan === 'free' && <div className="h-6 w-6 bg-[#C8F169] rounded-full flex items-center justify-center" data-id="element-3557">
                        <CheckIcon className="h-4 w-4 text-[#1E2A38]" data-id="element-3558" />
                      </div>}
                  </div>
                </div>
                {/* Standard Plan */}
                <div className={`border rounded-lg p-4 cursor-pointer transition-all ${formData.plan === 'standard' ? 'border-[#C8F169] bg-[#C8F169] bg-opacity-5' : 'border-[#F5F7FA] border-opacity-10 hover:border-[#F5F7FA] hover:border-opacity-30'}`} onClick={() => handleSelectPlan('standard')} data-id="element-3559">
                  <div className="flex justify-between items-center" data-id="element-3560">
                    <div data-id="element-3561">
                      <div className="flex items-center" data-id="element-3562">
                        <h3 className="font-medium" data-id="element-3563">Standard</h3>
                        <span className="ml-2 bg-[#C8F169] text-[#1E2A38] text-xs px-2 py-0.5 rounded" data-id="element-3564">
                          Popular
                        </span>
                      </div>
                      <p className="text-sm text-[#F5F7FA] text-opacity-70" data-id="element-3565">
                        $13/month
                      </p>
                    </div>
                    {formData.plan === 'standard' && <div className="h-6 w-6 bg-[#C8F169] rounded-full flex items-center justify-center" data-id="element-3566">
                        <CheckIcon className="h-4 w-4 text-[#1E2A38]" data-id="element-3567" />
                      </div>}
                  </div>
                </div>
                {/* Professional Plan */}
                <div className={`border rounded-lg p-4 cursor-pointer transition-all ${formData.plan === 'professional' ? 'border-[#C8F169] bg-[#C8F169] bg-opacity-5' : 'border-[#F5F7FA] border-opacity-10 hover:border-[#F5F7FA] hover:border-opacity-30'}`} onClick={() => handleSelectPlan('professional')} data-id="element-3568">
                  <div className="flex justify-between items-center" data-id="element-3569">
                    <div data-id="element-3570">
                      <h3 className="font-medium" data-id="element-3571">Professional</h3>
                      <p className="text-sm text-[#F5F7FA] text-opacity-70" data-id="element-3572">
                        $29/month
                      </p>
                    </div>
                    {formData.plan === 'professional' && <div className="h-6 w-6 bg-[#C8F169] rounded-full flex items-center justify-center" data-id="element-3573">
                        <CheckIcon className="h-4 w-4 text-[#1E2A38]" data-id="element-3574" />
                      </div>}
                  </div>
                </div>
                {/* Enterprise Plan */}
                <div className={`border rounded-lg p-4 cursor-pointer transition-all ${formData.plan === 'enterprise' ? 'border-[#C8F169] bg-[#C8F169] bg-opacity-5' : 'border-[#F5F7FA] border-opacity-10 hover:border-[#F5F7FA] hover:border-opacity-30'}`} onClick={() => handleSelectPlan('enterprise')} data-id="element-3575">
                  <div className="flex justify-between items-center" data-id="element-3576">
                    <div data-id="element-3577">
                      <h3 className="font-medium" data-id="element-3578">Enterprise</h3>
                      <p className="text-sm text-[#F5F7FA] text-opacity-70" data-id="element-3579">
                        Custom Pricing
                      </p>
                    </div>
                    {formData.plan === 'enterprise' && <div className="h-6 w-6 bg-[#C8F169] rounded-full flex items-center justify-center" data-id="element-3580">
                        <CheckIcon className="h-4 w-4 text-[#1E2A38]" data-id="element-3581" />
                      </div>}
                  </div>
                </div>
              </div>
              <div className="flex space-x-4" data-id="element-3582">
                <button type="button" onClick={() => setStep(1)} className="flex-1 bg-transparent border border-[#F5F7FA] border-opacity-20 text-[#F5F7FA] font-medium py-2 px-4 rounded-lg hover:bg-[#F5F7FA] hover:bg-opacity-5 transition-colors" data-id="element-3583">
                  Back
                </button>
                <button type="button" onClick={handleSubmit} disabled={!formData.plan} className={`flex-1 font-medium py-2 px-4 rounded-lg transition-colors ${formData.plan ? 'bg-[#3B82F6] hover:bg-opacity-90 text-white' : 'bg-[#3B82F6] bg-opacity-50 cursor-not-allowed text-white'}`} data-id="element-3584">
                  Complete Sign Up
                </button>
              </div>
            </div>}
        </div>
      </div>
    </div>;
}